shvenergy.byndervideoplayer = (function ($) {
    "use strict";

    function playbyndervideo(url) {

        var frame = document.createElement("div");
        frame.setAttribute("class", "videoframe");

        var video = document.createElement("video");
        video.setAttribute("controls", "");
        video.setAttribute("disablepictureinpicture", "true");
        video.setAttribute("controlslist", "nodownload");

        var source = document.createElement("source");
        video.setAttribute("src", url);
        video.setAttribute("type", "video/mp4");

        video.appendChild(source);
        frame.appendChild(video);
        shvenergy.modal.showModal(frame);
    }

    return {
        playbyndervideo: playbyndervideo
    };

})(jQuery);